// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2SC3Z","inline":"styles_inline__1tdfD"};